export default __webpack_public_path__ + "static/media/flag-china.ff5a34a1.svg";